import { defineRouteDef, z } from '@/domains/common/api';

export const getFtwAuthStatusRoute = defineRouteDef({
  method: 'GET',
  path: '/api/ftw/auth',
  audience: 'user',
  // `authenticated` = browser-login creds present (the FTWLink API key status is
  // independent and read server-side via hasFtwLinkConfig()).
  output: z.object({ authenticated: z.boolean() }),
});

export const saveFtwAuthRoute = defineRouteDef({
  method: 'POST',
  path: '/api/ftw/auth',
  audience: 'user',
  body: z.object({
    username: z.string().min(1),
    password: z.string().min(1),
    company_code: z.string().min(1),
  }),
  output: z.object({ ok: z.literal(true) }),
});
